import { ReferralSource } from "@/utils/referralSource";

/**
 * 紹介元の配列を受け取り、オプションの配列を返します。
 * @param referralSource - 紹介元の配列
 * @returns オプションの配列
 */
export const getReferralSourceOptions = (referralSource: ReferralSource[] | null): Option[] => {
  return (
    referralSource?.map(source => ({
      label: source.referralSourceName,
      value: String(source.referralSourceCd),
    })) || []
  );
};

/**
 * 指定されたIDに基づいて紹介元を取得します。
 * @param referralSource - 紹介元の配列
 * @param referralSourceCd - 検索する紹介元のID
 * @returns 指定されたIDの紹介元、見つからない場合はundefined
 */
export const getReferralSourceById = (referralSource: ReferralSource[] | null, referralSourceCd: number) => {
  return referralSource?.find(source => source.id === referralSourceCd);
};
